module.exports = __webpack_public_path__ + "img/20200514_154133.6507b9fd.jpg";